import {internalProps} from '../../../../types/BS_types'

export const connectionId = internalProps['teamcity.pipelines.gitHubConnectionId']
export const GITHUB_REPOSITORIES_ENDPOINT = `/oauth/github/listRepositories.html?projectId=_Root&connectionId=${connectionId}`
